<template>
    <div class="partner">
      <div class="partner-container">
<!--        标题-->
          <div class="partner-title">{{$t('Partner.title')}}</div>
          <div class="partner-line"></div>
<!--            内容-->
          <div class="partner-content">
            <div class="partner-img">
              <img src="../assets/image/partner/one-one.png"/>
              <img class="partner-img-s" style="" src="../assets/image/partner/one-two.png"/>
              <img class="partner-img-t"  src="../assets/image/partner/one-three.png"/>
              <img src="../assets/image/partner/one-four.png"/>
            </div>
            <div class="partner-img">
              <img src="../assets/image/partner/two-one.png"/>
              <img class="partner-img-s" src="../assets/image/partner/two-two.png"/>
              <img class="partner-img-t" src="../assets/image/partner/two-three.png"/>
              <img src="../assets/image/partner/two-four.png"/>
            </div>
            <div class="partner-img">
              <img src="../assets/image/partner/three-one.png"/>
              <img class="partner-img-s" src="../assets/image/partner/three-two.png"/>
              <img class="partner-img-t" src="../assets/image/partner/three-three.png"/>
              <img src="../assets/image/partner/three-four.png"/>
            </div>
            <div class="partner-img">
              <img src="../assets/image/partner/four-one.png"/>
              <img class="partner-img-s" src="../assets/image/partner/four-two.png"/>
              <img class="partner-img-t" src="../assets/image/partner/four-three.png"/>
              <img src="../assets/image/partner/four-four.png"/>
            </div>
            <div class="partner-img">
              <img src="../assets/image/partner/five-one.png"/>
              <img class="partner-img-s" src="../assets/image/partner/five-two.png"/>
              <img class="partner-img-t" src="../assets/image/partner/five-three.png"/>
              <img src="../assets/image/partner/five-four.png"/>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "Partner"
}
</script>

<style scoped lang="less">
.partner {
  background-image: url('http://cdn-cus.weixinhai.net/cdn/web/img/background.c81c003f.png');
  background-size: 100% 100%;
  .partner-container {
    //width: 1200px;
    margin: 0 auto;
    padding-top: 120px;
    padding-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    .partner-title {
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
    }
    .partner-line {
      margin-top: 40px;
      width: 40px;
      height: 4px;
      background: #2365D3;
    }
    .partner-content {
      margin-top: 30px;
      .partner-img {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        .partner-img-s {
          padding-left: 30px;
          padding-right: 30px
        }
        .partner-img-t {
          padding-right: 30px;
        }
        img {
          width: 200px;
          height: 60px;
        }
      }
    }
}
}

@media(max-width: 1200px) {
  .partner-container{
    width: 100%;
  }
}
@media(max-width: 480px) {
  .partner-container {
    padding-top: 60px;
    padding-bottom: 60px;
    .partner-title {
      font-size: 28px;
    }
    .partner-img {
      .partner-img-t {
        padding-left: 30px;
      }
      img {
        margin-top: 10px;
      }
    }
  }
}

</style>
